import {Databases, Query} from "appwrite";
import {client, database_id} from "../lib/appwrite";
import {v4 as uuidv4} from "uuid";
import {StatisticItem} from "../types/statistic";


const COLLECTION_ID = "682f5f93000d28f29dc3"
const databases = new Databases(client);

export const statisticService = {
  async create(data: StatisticItem): Promise<StatisticItem> {
    try {
      const createdItem = await databases.createDocument(
        database_id,
        COLLECTION_ID,
        uuidv4(),
        data
      ) as unknown as StatisticItem;

      return createdItem;
    } catch (error) {
      throw error;
    }
  },

  async update(data: StatisticItem): Promise<StatisticItem> {
    try {
      const id = data.$id as string
      const {$id, ...correctData} = data
      const updatedItem = await databases.updateDocument(
        database_id,
        COLLECTION_ID,
        id,
        correctData
      ) as unknown as StatisticItem;
      return updatedItem;
    } catch (error) {
      throw error;
    }
  },

  async list(queries: string[] = [], limit: number = 100): Promise<StatisticItem[]> {
    try {
      const response = await databases.listDocuments(
        database_id,
        COLLECTION_ID,
        [
          Query.limit(limit),
          ...queries
        ]
      );
      return response.documents.map(doc => doc as unknown as StatisticItem);

    } catch (error) {
      throw error;
    }
  },

  async delete(id: string): Promise<void> {
    try {
      await databases.deleteDocument(
        database_id,
        COLLECTION_ID,
        id
      );
    } catch (error) {
      throw error;
    }
  },


}